/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
// import ImageUploader from 'components_newui/new_ui_image_uploader/View'
import ImageUploader from 'components_newui/new_ui_image_uploader/ImageUploader1'
import { useFormContext,Controller } from 'react-hook-form';
import RichTextEditor from './components/RichTextEditor';

const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    basicDetailWrp:{
        margin: '1rem 0 2rem 0',
        padding: '1rem',
        background: '#fff'
    },
    title:{
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1.25rem',
        margin: '0 0 2rem 0', 
        textAlign: 'left',
        color:"#333",
      },
    fieldsetBox:{
        marginBottom:theme.spacing(1),
        border: 0,
        padding: 0,
        background: 'transparent',
        '& label':{
            fontFamily: 'VodafoneRg-bold', 
            fontSize: '1rem',
            margin: '1rem 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            display:'block',
        },
        '& input[type="text"],input[type="date"],select ':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '3rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            height:'48px'
        },
        '& input[type=date]:before':{content:'none'},
        '& textarea':{
            fontFamily: 'VodafoneRg-Regular', 
            fontSize: '1rem',
            margin: '0 0 0.5rem 0', 
            textAlign: 'left',
            color:"#333",
            background:'#fff',
            borderRadius:'4px',
            width: '100%',
            minHeight: '8.5rem',
            border: '1px solid #333',
            padding: '0.5rem',
            boxSizing: 'border-box',
            resize:'none'
        },
        
        
        
    },
    '& input[aria-invalid="true"]':{
        borderColor:'red',
    },
    error:{
        color:"red",
        fontFamily: 'VodafoneRg-Regular', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
    },
    labelname:{
        fontFamily: 'VodafoneRg-bold', 
        fontSize: '1rem',
        margin: '0 0 0.5rem 0', 
        textAlign: 'left',
        color:"#333",
        display:'block',
    },
    
    invalid: {
        borderColor: 'red !important',
    },
    
    wrp2cols:{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '1rem'
    },
    backButton: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));
  

export const ChallengeDetails = (props) => {
    const { innovateCategoryTypes:innovateTypes , postInnovateChallengeImageFn,getInnovateChallengeDraftIdAddImage,getInnovateChallengeDraftIdAddImageLoading,deleteImageFn,draftIdForImage} = props || {}
    const {mainImageValue = [],image} = getInnovateChallengeDraftIdAddImage || {}
    // console.log("🚀 ~ ChallengeDetails ~ mainImageValue:", mainImageValue, image)
    const classes = useStyles();
    const { register, control,watch,formState: { errors } } = useFormContext();

    // useEffect(()=>{
    //     if(mainImageValue !== null) {
    //         // getInnovateChallengeDraftIdAddImage()
    //     }
    // },[mainImageValue])

// const handleImageupload = image => onSelectImage(ideaUrlId, image)
// const handleDeleteImage = (newImages, _imageName, imageToDelete)  =>{
//   const { onDeleteImage } = props
//   onDeleteImage(ideaUrlId, newImages, imageToDelete)
// } 
// console.log("errors",errors)

  return (
    <div className={classes.basicDetailWrp}>
        <h2 className={classes.title}>Basic Details</h2>

        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='isHackathonChallenge'> Select this challenge for the hackathon or not? </label>
              <select
                  name="isHackathonChallenge"
                  id="isHackathonChallenge"
                  {...register('isHackathonChallenge')}
                  className={`${errors?.isHackathonChallenge ? classes.invalid : ''}`}
              >
                 <option value="">Select...</option>
                  <option value="true"> Yes </option>
                  <option value="false"> No </option>
                  
              </select>

            {errors?.isHackathonChallenge?.message && <p className={classes.error}>{errors?.isHackathonChallenge?.message}</p>}
        </fieldset>

        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='title'>Challenge Title</label>
            <input 
              maxLength={100}
                type='text' 
                name="title" 
                id='title'  
                placeholder='Enter a descriptive title of your challenge' 
                {...register('title')}
                className={` ${errors?.title ? classes.invalid: ''}`}
                aria-invalid={errors?.title ? "true" : "false"}
                
            />
            {errors?.title?.message && <p className={classes.error}>{errors?.title?.message}</p>}
        </fieldset>
        {/* <fieldset className={classes.fieldsetBox}>
            <label htmlFor='summary'>Challenge Description</label>
            <textarea  
                className={` ${errors?.summary ? classes.invalid: ''}`}
                name="summary" 
                id='summary'  
                placeholder='Describe the challenge, goal and expected outcomes' 
                {...register('summary')}
            />
            {errors?.summary?.message && <p className={classes.error}>{errors?.summary?.message}</p>}
        </fieldset> */}

<fieldset className={classes.fieldsetBox}>
  <label htmlFor="summary">Challenge Description</label>

  <Controller
    name="summary"
    control={control}
    render={({ field }) => (
      <RichTextEditor
        id="summary"
        value={field.value}
        onChange={field.onChange}
        className={`${errors?.summary ? classes.invalid : ''}`}
        placeholder="Describe the challenge, goal and expected outcomes"
      />
    )}
  />

  {errors?.summary?.message && (
    <p className={classes.error}>{errors.summary.message}</p>
  )}
</fieldset>

        <fieldset className={classes.fieldsetBox}>
            <label htmlFor='Category'> Category</label>
              <select
                  name="category"
                  id="category"
                  {...register('category')}
                  className={`${errors?.category ? classes.invalid : ''}`}
              >
                  <option value="">Select...</option>
                  {innovateTypes.map(type => (
                      <option key={type.id} value={type.id}>
                          {type.name}
                      </option>
                  ))}
              </select>

            {errors?.category?.message && <p className={classes.error}>{errors?.category?.message}</p>}
        </fieldset>
        
        <div className={classes.wrp2cols}>
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='startingDate'>Submission Start Date</label>
                <input 
                    type="date"  
                    name="startingDate" 
                    id='startingDate'  
                    className={` ${errors?.startingDate ? classes.invalid: ''}`}
                      {...register('startingDate', {
                          validate: value => {
                              if (!value) return 'Start date is required';
                              const today = new Date();
                              today.setHours(0, 0, 0, 0); // Remove time part
                              if (new Date(value) < today) {
                                  return 'Start date cannot be in the past';
                              }
                              return true;
                          }
                      })}
    
                />
                 {errors?.startingDate?.message && <p className={classes.error}>{errors?.startingDate?.message}</p>}
            </fieldset>
            <fieldset className={classes.fieldsetBox}>
                <label htmlFor='closingDate'>Submission End Date</label>
                <input 
                    type="date"  
                    name="closingDate" 
                      id='closingDate'
                      className={` ${errors?.closingDate ? classes.invalid: ''}`}
                      {...register('closingDate')}
                />
                 {errors?.closingDate?.message && <p className={classes.error}>{errors?.closingDate?.message}</p>}
            </fieldset>
        </div>

        <div >
            <h3 className={classes.labelname}>Challenge Cover Photo</h3>
            {/* <NxtCircularLoader isLoading={false} > */}
            <Controller
  name="coverPhoto"
  control={control}
  rules={{ required: 'Challenge cover photo is required' }}
  render={({ field }) => (
    <ImageUploader
      classes={classes}
      images={field.value || []}

      onSelectImage={async (id,img) => {

        console.log("🚀 ~ async ~ idea create img:", img)
        const file = img?.file;

        if (!file || typeof file.size !== 'number') {
            alert("Invalid file or file size not available.");
            return;
        }

        const fileSizeMB = file.size / (1024 * 1024);

        if (Number.isNaN(fileSizeMB) || fileSizeMB > 10) {
            alert("Image size should be less than 10 MB");
            return;
        }

        try {        
          await postInnovateChallengeImageFn(id,img);
          // if (uploaded?.url) {
            field.onChange([{ ...img, src: img?.src }]);
          // }
        } catch (error) {
          console.error("Image upload failed", error);
          // Optionally show a user-friendly error message
        }
      }}
  
      // onSelectImage={async (selectedImage) => {
      //   try {
      //      postInnovateChallengeImageFn(selectedImage);
      //     field.onChange(image); // Set the uploaded image URL or object
      //   } catch (error) {
      //     console.error('Image upload failed:', error);
      //     // Optionally show an error to the user
      //   }
      // }}
      deleteImage={async (id,deletedImage) => {
       await deleteImageFn(id,deletedImage);
        field.onChange(null); // Clear the field if image is deleted
      }}
      isInnovateOneImageOnly
      subtitle="Browse image"
      isLoader={getInnovateChallengeDraftIdAddImageLoading}
      IdForImage={draftIdForImage}
    />
  )}
/>



{/* </NxtCircularLoader> */}
{errors?.coverPhoto?.message && (
  <p className={classes.error}>{errors.coverPhoto.message}</p>
)}

{/* 
              <Controller
                  name="images"
                  control={control}
                  rules={{ required: 'Challenge cover photo is required' }}
                  
                  render={({ field }) => (
                    <>                       {//console.log("fields==>", field) 
                    }
                      <ImageUploader
                        //   images={image || []}
                            mainImageValue={mainImageValue || []}
                        //   onSelectImage={(img) => field.onChange([img])}
                          onSelectImage={postInnovateChallengeImageFn}
                          isInnovateOneImageOnly
                        //   isOneImageOnly
                          deleteImage={deleteImage}
                        //   deleteImage={() => field.onChange(deleteImage || [])}
                          subtitle="Browse image"
                          imageUploadError=""
                          UploadLimit={1}
                        //   imagesLength={(image || []).length }
                      />
                 </> )}
              />
                {errors?.coverPhoto?.message && <p className={classes.error}>{errors?.coverPhoto?.message}</p>} */}
        </div>
       
       
        {/* <fieldset className={classes.fieldsetBox}>
            <label htmlFor='termsAndConditions'>Challenge Specific Terms and Conditions</label>
            <textarea  
                name="termsAndConditions" 
                id='termsAndConditions'  
                placeholder='Terms and Conditions' 
                className={` ${errors?.termsAndConditions ? classes.invalid: ''}`}
                {...register('termsAndConditions')}
            />
            
           
             {errors?.termsAndConditions?.message && <p className={classes.error}>{errors?.termsAndConditions?.message}</p>}
        </fieldset> */}

<fieldset className={classes.fieldsetBox}>
  <label htmlFor="termsAndConditions">Challenge Specific Terms and Conditions</label>

  <Controller
    name="termsAndConditions"
    control={control}
    render={({ field }) => (
      <RichTextEditor
        id="termsAndConditions"
        value={field.value}
        onChange={field.onChange}
        className={`${errors?.termsAndConditions ? classes.invalid : ''}`}
        placeholder="Terms and Conditions"
      />
    )}
  />

  {errors?.termsAndConditions?.message && (
    <p className={classes.error}>{errors.termsAndConditions.message}</p>
  )}
</fieldset>


    </div>
  )
}
